// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"quote"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10.0001 6H3.5V12H8.00009L5.33343 18H6.00009L10.0001 12.3333V6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.5 6H14V12H18.5L15.8333 18H16.5L20.5 12.3333V6Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10.0001 6H3.5V12H8.00009L5.33343 18H6.00009L10.0001 12.3333V6Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M20.5 6H14V12H18.5L15.8333 18H16.5L20.5 12.3333V6Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const QuoteIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'quote',
    ref,
    icon: element,
  },
));

QuoteIcon.displayName = 'QuoteIcon';

export default QuoteIcon;
